var map = {
	"./logo.png": 6949,
	"./logo.svg": 9574,
	"./oscar-wide.jpg": 9360,
	"./oscar.jpg": 9527,
	"./popcorn.jpg": 775,
	"./recording-gear.jpg": 7689
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7173;